import React from "react";

const Error = props => {
  return <div className="content-body error-body">{props.children}</div>;
};

export default Error;
